$('.shop-matrix__item-arrow-down').on('click', function () {
    const $parent = $(this).closest('.shop-matrix__item');

    $parent.find('.shop-matrix__item-address-box').slideToggle();
    $parent.toggleClass('shop-matrix__item-active');
});